<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item v-if="canViewAccounting" router-link to="/accounting/payoff">
                    <icon name="file-invoice"></icon>
                    บันทึกรับ
                </b-nav-item>&nbsp
                <b-nav-item v-if="canViewAccounting || canViewPurchases" router-link to="/accounting/invoice-payoff-other">
                    <icon name="file-invoice"></icon>
                    บันทึกรับอื่นๆ
                </b-nav-item>&nbsp
                <b-nav-item v-if="canViewAccounting" router-link to="/accounting/invoice-payoff-account">
                    <icon name="file-invoice-dollar"></icon>
                    รหัสบัญชีสำหรับบันทึกรับ
                </b-nav-item>&nbsp
                <b-nav-item v-if="canViewAccounting || canSaleView" router-link to="/accounting/cheque-list">
                    <icon name="money-check"></icon>
                    รายการเช็ค
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    import {canViewAccounting,canSaleView,canViewPurchases} from '../../util/Permissions';

    export default {
        name: "accounting-billing-payoff-layout",
        computed:{
            canViewAccounting,canSaleView,canViewPurchases
        }
    };
</script>

<style lang="scss" scoped></style>
